/** SELF Phone catalog + inventory constants (keep in sync with Stripe checkout). */
export const SELF_PHONE_PRICE_CENTS = 99900;
export const SELF_PHONE_PRICE_LABEL = '$999';
export const SELF_PHONE_TOTAL_UNITS = 50;

export type { PhoneBatch, PhoneBatchState, BatchStatus } from './selfPhoneBatches';
import type { PhoneBatch } from './selfPhoneBatches';

export type PhoneInventory = {
  total: number;
  sold: number;
  remaining: number;
  soldOut: boolean;
  currentBatch: number | null;
  currentBatchShipLabel: string | null;
  currentBatchRemaining: number;
  currentBatchSize: number;
  currentBatchSold: number;
  nextOrderBatch: number | null;
  nextOrderShipLabel: string | null;
  batches: PhoneBatch[];
};
